export class DocumentReview {

  private entityType = 'doc-review';

  associatedParty: any;
  attachments: string[] = [];
  assignedTo: any;  // Called "Submitted To" in the intake and columns
  approvedTemplate: boolean;
  baas: any[] = [];
  CreatedDate: any;
  closedDate: any;
  contractType: any;
  cois: any[] = [];
  description: any;
  departments: any;
  documentType: any;
  documentList: any[] = [];
  documentOriginal: any;
  directBaa: any;  // OLD - NOT USED - REMOVE
  directCoi: any;  // OLD - NOT USED - REMOVE
  effectiveDate: any;
  EntityId: any;
  embeddedBaa = false;
  entityDirectLink: any;  // Maybe not used???
  entityUnderReviewId: any;
  entityUnderReviewType: any;
  entityUnderReviewObject: any = null;
  externalReviewerList: string[] = [];
  externalDocument: boolean;
  executiveSponsor: any;
  Id: any;
  importantDates: string[] = [];
  internalCoordinators: any[] = [];
  internalReviewerList: any[] = [];
  internalSignatories: any[] = [];
  internalDocument: boolean;
  lastActionDate: any;
  legalEntities: any;
  masterContract: any;
  mainFileDirectLink: any;
  mainFileName: any;
  mainFileAttachmentNumber: any;
  mainFilePreviousVersions: any[];
  masterSubordinate: any;
  name: any;
  notes = [];
  notesAssignment: any;
  owner: any;
  party: any;
  partyContractCoordinators: any = [];
  partySignatories: any = [];
  phase: any;
  physician = {
    Termsheet: null,
    FMV: null,
    AcceptanceLetter: null
  }
  physicianEmploymentAgreement: any;
  priority: any;
  questions: any;
  requestor: any;
  requestorNotes: any;
  renewalType: any;
  secondaryOwner: any;
  sites: any;
  Status: any;
  SubType: any;
  SubmissionDate: any;
  taskingAssignments: any[] = [];
  term: any;
  threshold: any;
  transactionType: any;
  Type: any;
  version: any;
  watcherList: string[] = [];
  riskAssessments: any[];
  provisions: string[];

}
